(function() {
	'use strict';
	angular.module('app.setup')
		.controller('addTemplateTaskForm', addTemplateTaskForm);

	addTemplateTaskForm.$inject = ['$scope', 'newProjectService', 'projectTemplatesService', 'storeService'];
	
	function addTemplateTaskForm($scope, newProjectService, projectTemplatesService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		vm.templateNdx = $scope.templateNdx;
		vm.action = $scope.action;
		vm.leanDirFactoryNdx = adminConfig.factory.id;
		vm.firstTimeEdit = true;
		vm.alternateUserList = [];
		vm.filterManagers = filterManagers;
		vm.clear = clear;
		// view model functions
		vm.close = close;
		vm.save = save;
		vm.isSaveButtonDisabled = false;
		vm.task = $scope.task || {};
		vm.taskGroups = [{
			id: -1,
			name: 'Ungrouped Tasks'
		}];
		
		function init() {
			getDropDownListsFromServer();
			vm.task.taskGroupNdx = vm.task.projectTaskGroupId || -1;
			vm.task.taskResponsibleNdx = vm.task.taskResponsibleId;
		}
		
		function save() {
			vm.isSaveButtonDisabled = true;
			var taskForSave = getTaskForSave();
			projectTemplatesService.saveTemplateTask(vm.templateNdx, taskForSave, adminConfig.factory.id).then(function(message) {
				$scope.result(message, message === 'Template task saved successfully');
				vm.isSaveButtonDisabled = false;
			});
		}
		
		function close() {
			$scope.result('', false);
		}

		function getDropDownListsFromServer() {
			newProjectService.getUsers(vm.leanDirFactoryNdx, null, true).then(function (users) {
				vm.alternateUserList = users;
				vm.taskManagers = users;
			});

			projectTemplatesService.getTemplateTaskGroups(vm.templateNdx, vm.leanDirFactoryNdx).then(function (taskGroups) {
				vm.taskGroups = vm.taskGroups.concat(taskGroups);
			});
		}

		function filterManagers(searchTerm) {
			if (vm.firstTimeEdit && searchTerm == '') {
				return vm.alternateUserList;
			} else {
				vm.firstTimeEdit = false;
				return newProjectService.filterUsers(vm.taskManagers, searchTerm);
			}
		}

		function clear() {
			vm.task.taskResponsibleNdx = null;
		}

		function getTaskForSave() {
			var taskForSave = _.pick(vm.task,
				'ndx',
				'name',
				'description',
				'startDayOffsetInt',
				'durationInt',
				'taskResponsibleNdx',
				'taskGroup',
				'taskGroupNdx'
			);
			if (!taskForSave.taskResponsibleNdx && vm.action === 'Edit') {
				taskForSave.taskResponsibleNdx = 0;
			}
			if (taskForSave.taskGroupNdx === -1) {
				delete taskForSave.taskGroupNdx;
			}
			return taskForSave;
		}

		init();
	}
})();
